import { render, staticRenderFns } from "./WorkspaceMenuChannelList.vue?vue&type=template&id=d4fd6dca&scoped=true"
import script from "./WorkspaceMenuChannelList.vue?vue&type=script&lang=ts"
export * from "./WorkspaceMenuChannelList.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceMenuChannelList.vue?vue&type=style&index=0&id=d4fd6dca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fd6dca",
  null
  
)

export default component.exports